import React from 'react';
import PropTypes from 'prop-types';
import { ActionProps } from './Action.types';

export const Action = ({ children }: ActionProps) => {
  return React.cloneElement(children, {
    style: {
      ...children.props.style,
      position: 'relative',
      zIndex: 1,
    },
  });
};

Action.displayName = 'Action';

Action.propTypes = {
  children: PropTypes.any,
};

export default Action;
